import { render, staticRenderFns } from "./ArchiveUnitDialog.vue?vue&type=template&id=5f7b9ee0&scoped=true&"
import script from "./ArchiveUnitDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveUnitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b9ee0",
  null
  
)

export default component.exports